var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000064",
    strokeWidth: 1.5,
    d: "M.543 3.943h4.356M12.158 3.943h11.615"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.529,
    cy: 3.967,
    r: 2.88,
    stroke: "#000064",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000064",
    strokeWidth: 1.5,
    d: "M23.774 17.057h-4.356M12.158 17.057H.544M12.91 17.034a2.88 2.88 0 115.758 0 2.88 2.88 0 01-5.759 0z"
  })));
}
export default SvgIconFilter;